export default __webpack_public_path__ + "h8.png";